var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { convertObject2Array } from './util';
export default function (_a) {
    var _b, _c;
    var env = _a.env, data = _a.data, inputs = _a.inputs, outputs = _a.outputs, onError = _a.onError;
    var fns = data.fns, runImmediate = data.runImmediate;
    var isDebug = (_b = env.runtime) === null || _b === void 0 ? void 0 : _b.debug;
    var runJSParams = {
        outputs: convertObject2Array(outputs),
        env: {
            executeSql: function (sql) { return env.executeSql(sql); },
            genUniqueId: env.genUniqueId,
            getEntityName: isDebug ? function (_) { return _; } : env.getEntityName,
            encrypt: env.encrypt,
            decrypt: env.decrypt,
        },
    };
    try {
        if (runImmediate) {
            if (env.runtime) {
                eval(decodeURIComponent(fns.transformCode || fns))(runJSParams);
            }
        }
        inputs['input'](function (val) {
            var _a;
            env.collect('执行 JS计算: ', val);
            try {
                eval(decodeURIComponent(fns.transformCode || fns))(__assign(__assign({}, runJSParams), { inputs: convertObject2Array(val) }));
                env.collect('执行 JS计算 结束: ', val);
            }
            catch (ex) {
                onError === null || onError === void 0 ? void 0 : onError(ex.message);
                env.edit ? console.error('js计算组件运行错误.', ex) : (_a = env.logger) === null || _a === void 0 ? void 0 : _a.error("".concat(ex));
            }
        });
    }
    catch (ex) {
        onError === null || onError === void 0 ? void 0 : onError(ex.message);
        env.edit ? console.error('js计算组件运行错误.', ex) : (_c = env.logger) === null || _c === void 0 ? void 0 : _c.error("".concat(ex));
    }
}
